import { slugifyPayload } from '@gaming1/g1-utils';

import { GetPaginatedGameListRequest } from './types';

export const slugifyGameListPayload = (payload: GetPaginatedGameListRequest) =>
  slugifyPayload(payload, ['PageNumber']);
